export default "__VITE_ASSET__CSjIkuLu__"